<template>
    <div class="page orderFinish">
        <div class="container mediaHideOnDesctop">
            <div class="h1">
                We’ve received your order!
            </div>
            <div class="h5">
                Pickup<br>Location:
            </div>
            <div class="address">
                <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z" fill="#CF3339"/>
                </svg>
                <span class="caption">
                    {{ confirmationValues.business.fullAddress() }}
                </span>
            </div>
            <div class="bigBag">
                <img :src="getStaticImage('bigBag.png')">
            </div>
            <div class="orderComplete">
                Your order will be ready at {{ confirmationValues.order_time }}, see you soon!
            </div>
            <div class="btnBox">
                <a class="btnlink zbg inv" target="_system" :href="'tel:' + confirmationValues.business.phone">
                    call store
                </a>
            </div>
        </div>
        <div class="descktopMediaBox container text-center">
            <div class="h1">
                Thank you for your order!
            </div>
            <div class="h2" v-if="user">Receipt of your order has been sent to {{ user.email }}</div>
            <div class="h2" v-if="cart.tempUser">Receipt of your order has been sent to {{ cart.tempUser.email }}</div>
            <router-link v-if="user" :to="{name: 'OrderHistory'}">
                View your receipt
            </router-link>
        </div>
        <div class="container">
            <div class="btnBox">
                <router-link class="btnlink zbg" :to="{name: 'Home'}">
                    back to home
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PickupComplete",
        created() {
            this.$store.commit("shared/setTopBar", {title: "In-Store Pickup"});
        },
        computed : {
            confirmationValues(){
                return this.$store.state.cart.confirmationValues;
            },
            cart(){
                return this.$store.state.cart;
            }
        },
        destroyed() {
            this.$store.commit("cart/setTempUser", null);
        }
    }
</script>
